// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TriangleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TriangleIcon" ref={forwardedRef} {...props}>
      <path d="M9.57 2.975C9.273 3.117 9.048 3.54 8.597 4.387L2.994 14.913c-.406.763-.609 1.144-.572 1.455a1 1 0 0 0 .422.703c.258.179.69.179 1.553.179h11.205c.864 0 1.296 0 1.554-.179a1 1 0 0 0 .422-.703c.037-.311-.166-.692-.572-1.455L11.404 4.387c-.451-.847-.677-1.27-.975-1.412a1 1 0 0 0-.858 0m6.112 12.643.07.132H4.247l.071-.132L9.921 5.092 10 4.942l.08.15z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TriangleIcon = /* @__PURE__ */ Object.assign(
  TriangleIconComponent,
  { displayName: 'TriangleIcon' },
);
